import React, { useEffect, useState, lazy, Suspense } from 'react';
import Header from './Header';
import { getDashboardDetails } from '../../utils/api';
import '../../styles/OwnerAdmin.css';

const Dashboard = ({ nodeId, currentTheme, setSelectedNodeId }) => { // Accept currentTheme as a prop
  const [Component, setComponent] = useState(null);
  const [dashboardData, setDashboardData] = useState(null);
  const [showRedirectPopUp, setShowRedirectPopUp] = useState(false);
  const [showOptionalRedirectPopUp, setShowOptionalRedirectPopUp] = useState(false);
  const [redirectedDashboardId, setRedirectedDashboardId] = useState(null);

  useEffect(() => {
    const fetchDashboardDetails = async () => {
      try {
        const data = await getDashboardDetails(nodeId);
        console.log("Dashboard details:", data);
        if (data[0].target_dashboard_id){
          console.log("I am redirecting to target dashboard:", data[0].target_dashboard_id);
          setRedirectedDashboardId(data[0].target_dashboard_id);
          console.log(data[0].redirect_type);
          if (data[0].redirect_type === 'Optional Redirect') {
            setShowOptionalRedirectPopUp(true);
          } else if (data[0].redirect_type === 'Noticed Redirect') {
            setShowRedirectPopUp(true);
          } else {
            setSelectedNodeId(data[0].target_dashboard_id);
          }
        }

        if (data[0].component_name) {
          const DynamicComponent = lazy(() => import(`./embeds/${data[0].component_name}`));
          setComponent(() => DynamicComponent);
          setDashboardData(data[0]);
        }
      } catch (error) {
        console.error('Error fetching dashboard details:', error);
      }
    };

    fetchDashboardDetails();
  }, [nodeId]);

  const handleRedirect = () => {
    setShowOptionalRedirectPopUp(false);
    setShowRedirectPopUp(false);
    console.log("Redirecting to dashboard:", redirectedDashboardId);
    setSelectedNodeId(redirectedDashboardId);
  }

  return (
    <div>
      <Header dashboardData={dashboardData} currentTheme={currentTheme} /> {/* Pass currentTheme */}
      <div className="dashboard-content">
        {Component && dashboardData && (
            <Suspense fallback={<div>Loading...</div>}>
              <Component dashboardData={dashboardData} />
            </Suspense>
        )}
      </div>
      {showOptionalRedirectPopUp && (
          <div className="popup-overlay">
            <div className="popup-content">
              <p>This dashboard redirects to another dashboard. Do you want to go there?</p>
              <button onClick={handleRedirect}>OK</button>
              <button onClick={() => setShowOptionalRedirectPopUp(false)}>Cancel</button>
            </div>
          </div>
      )}
      {showRedirectPopUp && (
          <div className="popup-overlay">
            <div className="popup-content">
              <p>This dashboard redirects to another dashboard.</p>
              <button onClick={handleRedirect}>OK</button>
            </div>
          </div>
      )}
    </div>
  );
};

export default Dashboard;